import type { ComponentProps, ReactNode } from 'react';
import { cn } from '../lib/utils.js';

interface EmptyStateProps extends ComponentProps<'div'> {
  readonly icon?: ReactNode;
  readonly title: string;
  readonly description?: string;
  readonly primaryAction?: ReactNode;
  readonly secondaryAction?: ReactNode;
}

export function EmptyState({
  icon,
  title,
  description,
  primaryAction,
  secondaryAction,
  className,
  ...props
}: Readonly<EmptyStateProps>) {
  return (
    <div
      data-slot="empty-state"
      className={cn('flex flex-col items-center justify-center gap-4 p-12 text-center', className)}
      {...props}
    >
      {icon !== undefined && (
        <div className="bg-accent/10 text-accent flex size-16 items-center justify-center rounded-full">
          {icon}
        </div>
      )}
      <div className="flex flex-col gap-1.5">
        <h3 className="text-foreground text-base font-semibold leading-none">{title}</h3>
        {description !== undefined && (
          <p className="text-muted-foreground max-w-sm text-sm">{description}</p>
        )}
      </div>
      {(primaryAction !== undefined || secondaryAction !== undefined) && (
        <div className="mt-2 flex flex-col items-center gap-2 sm:flex-row">
          {primaryAction}
          {secondaryAction}
        </div>
      )}
    </div>
  );
}
